export const frontendData = {
  id: 'frontend',
  title: 'Frontend Developer',
  icon: 'Globe',
  color: 'from-green-500 to-emerald-600',
  description: 'Recursos de desarrollo frontend, frameworks y herramientas',
  categories: [
    {
      name: 'Frameworks & Librerías',
      icon: 'Code',
      resources: [
        {
          id: 'react-1',
          title: 'React Hooks - Guía Avanzada',
          type: 'Tutorial',
          description: 'Uso avanzado de React Hooks y patrones modernos para crear componentes más eficientes y mantenibles. Incluye ejemplos prácticos y mejores prácticas.',
          tags: ['React', 'Hooks', 'JavaScript'],
          difficulty: 'Intermedio',
          estimatedTime: '2h',
          lastUpdated: '2024-01-15',
          author: 'React Team',
          downloads: 245,
          rating: 4.9,
          content: {
            sections: [
              {
                title: 'useState y useEffect',
                content: 'Fundamentos de los hooks más utilizados en React, manejo de estado local y efectos secundarios.',
                subsections: [
                  'Estado local con useState',
                  'Efectos con useEffect',
                  'Dependencies array',
                  'Cleanup functions',
                  'Casos de uso comunes'
                ]
              },
              {
                title: 'useContext y useReducer',
                content: 'Gestión de estado global y lógica compleja de estado con hooks avanzados.',
                subsections: [
                  'Context API con useContext',
                  'useReducer para estado complejo',
                  'Combinando Context y useReducer',
                  'Performance considerations',
                  'Alternativas modernas'
                ]
              },
              {
                title: 'Custom Hooks',
                content: 'Creación de hooks personalizados para reutilizar lógica entre componentes.',
                subsections: [
                  'Reglas de los hooks',
                  'Extractando lógica común',
                  'Hooks para APIs',
                  'Hooks para formularios',
                  'Testing custom hooks'
                ]
              },
              {
                title: 'useMemo y useCallback',
                content: 'Optimización de performance con memoización de valores y funciones.',
                subsections: [
                  'Cuándo usar useMemo',
                  'Cuándo usar useCallback',
                  'Dependency arrays',
                  'Performance profiling',
                  'Common pitfalls'
                ]
              },
              {
                title: 'useRef y useImperativeHandle',
                content: 'Referencias a elementos DOM y exposición de métodos de componentes.',
                subsections: [
                  'Referencias a elementos',
                  'Persistencia de valores',
                  'useImperativeHandle',
                  'Forwarding refs',
                  'Casos de uso avanzados'
                ]
              }
            ]
          },
          attachments: [
            {
              name: 'React-Hooks-Guia.pdf',
              type: 'application/pdf',
              size: 2560000
            },
            {
              name: 'ejemplos-hooks.zip',
              type: 'application/zip',
              size: 1024000
            }
          ],
          externalLinks: [
            {
              title: 'React Hooks Documentation',
              description: 'Documentación oficial de React Hooks',
              url: 'https://react.dev/reference/react/hooks'
            }
          ]
        },
        {
          id: 'react-2',
          title: 'React Testing - Jest + Testing Library',
          type: 'Guía',
          description: 'Testing completo de componentes React con Jest y React Testing Library, incluyendo testing de hooks, eventos y integración.',
          tags: ['React', 'Testing', 'Jest'],
          difficulty: 'Intermedio',
          estimatedTime: '2.5h',
          lastUpdated: '2024-01-12',
          author: 'Testing Team',
          downloads: 178,
          rating: 4.7,
          content: {
            sections: [
              {
                title: 'Configuración de Jest',
                content: 'Setup completo del entorno de testing con Jest para proyectos React.',
                subsections: [
                  'Instalación de dependencias',
                  'Configuración de Jest',
                  'Setup files',
                  'Environment variables',
                  'Mock configuration'
                ]
              },
              {
                title: 'Testing de Componentes',
                content: 'Estrategias para testing de componentes React de manera aislada.',
                subsections: [
                  'Rendering components',
                  'Props testing',
                  'Conditional rendering',
                  'Component composition',
                  'Snapshot testing'
                ]
              },
              {
                title: 'Testing de Hooks',
                content: 'Testing de custom hooks y hooks nativos de React.',
                subsections: [
                  'Testing custom hooks',
                  'Hook testing utilities',
                  'Async hooks',
                  'Hook dependencies',
                  'Hook cleanup'
                ]
              },
              {
                title: 'Testing de Eventos',
                content: 'Simulación de interacciones del usuario y testing de eventos.',
                subsections: [
                  'User interactions',
                  'Event simulation',
                  'Form submissions',
                  'Async events',
                  'Event handlers'
                ]
              },
              {
                title: 'Mocking de APIs',
                content: 'Simulación de llamadas a APIs y servicios externos.',
                subsections: [
                  'Mock service worker',
                  'Jest mocks',
                  'API responses',
                  'Error scenarios',
                  'Loading states'
                ]
              }
            ]
          },
          externalLinks: [
            {
              title: 'React Testing Library',
              description: 'Guía oficial de React Testing Library',
              url: 'https://testing-library.com/docs/react-testing-library/intro'
            }
          ]
        },
        {
          id: 'vue-1',
          title: 'Vue.js 3 - Composition API',
          type: 'Tutorial',
          description: 'Migración a Vue 3 y uso de Composition API para crear componentes más organizados y reutilizables.',
          tags: ['Vue.js', 'Composition API', 'JavaScript'],
          difficulty: 'Intermedio',
          estimatedTime: '2h',
          lastUpdated: '2024-01-18',
          author: 'Vue Team',
          downloads: 156,
          rating: 4.6,
          content: {
            sections: [
              {
                title: 'Setup Function',
                content: 'Uso de la función setup para organizar la lógica de componentes.',
                subsections: [
                  'Setup function syntax',
                  'Return values',
                  'Props y context',
                  'Lifecycle integration',
                  'Composition vs Options'
                ]
              },
              {
                title: 'Reactive References',
                content: 'Sistema de reactividad con ref y reactive en Vue 3.',
                subsections: [
                  'ref() para valores primitivos',
                  'reactive() para objetos',
                  'Reactivity caveats',
                  'Unwrapping refs',
                  'Template refs'
                ]
              },
              {
                title: 'Computed Properties',
                content: 'Propiedades computadas reactivas con computed().',
                subsections: [
                  'Basic computed',
                  'Computed setters',
                  'Computed caching',
                  'Performance considerations',
                  'Testing computed'
                ]
              },
              {
                title: 'Watchers',
                content: 'Observadores reactivos con watch y watchEffect.',
                subsections: [
                  'watch() function',
                  'watchEffect() function',
                  'Watch options',
                  'Cleanup functions',
                  'Deep watching'
                ]
              },
              {
                title: 'Lifecycle Hooks',
                content: 'Hooks de ciclo de vida en Composition API.',
                subsections: [
                  'onMounted',
                  'onUnmounted',
                  'onUpdated',
                  'onBeforeMount',
                  'Custom lifecycle hooks'
                ]
              }
            ]
          },
          attachments: [
            {
              name: 'Vue3-Composition-API.pdf',
              type: 'application/pdf',
              size: 2048000
            }
          ]
        }
      ]
    },
    {
      name: 'Testing & Calidad',
      icon: 'Shield',
      resources: [
        {
          id: 'testing-1',
          title: 'Frontend Testing - Estrategias',
          type: 'Guía',
          description: 'Estrategias comprehensivas de testing para aplicaciones frontend, incluyendo diferentes niveles y herramientas.',
          tags: ['Testing', 'Frontend', 'Calidad'],
          difficulty: 'Intermedio',
          estimatedTime: '2h',
          lastUpdated: '2024-01-10',
          author: 'QA Team',
          downloads: 189,
          rating: 4.8,
          content: {
            sections: [
              {
                title: 'Unit Testing',
                content: 'Testing de unidades individuales de código, funciones y componentes.',
                subsections: [
                  'Testing functions',
                  'Testing utilities',
                  'Mocking dependencies',
                  'Test isolation',
                  'Coverage metrics'
                ]
              },
              {
                title: 'Integration Testing',
                content: 'Testing de la integración entre diferentes partes de la aplicación.',
                subsections: [
                  'Component integration',
                  'API integration',
                  'State management',
                  'Routing testing',
                  'Error boundaries'
                ]
              },
              {
                title: 'E2E Testing',
                content: 'Testing end-to-end que simula el comportamiento real del usuario.',
                subsections: [
                  'User journey testing',
                  'Cross-browser testing',
                  'Performance testing',
                  'Accessibility testing',
                  'Mobile testing'
                ]
              },
              {
                title: 'Visual Testing',
                content: 'Testing de la apariencia visual y regresiones en la UI.',
                subsections: [
                  'Screenshot testing',
                  'Visual regression',
                  'Design system testing',
                  'Responsive testing',
                  'Animation testing'
                ]
              },
              {
                title: 'Performance Testing',
                content: 'Testing de performance y métricas de rendimiento.',
                subsections: [
                  'Lighthouse metrics',
                  'Bundle analysis',
                  'Runtime performance',
                  'Memory leaks',
                  'Loading times'
                ]
              }
            ]
          },
          externalLinks: [
            {
              title: 'Frontend Testing Guide',
              description: 'Guía completa de testing frontend',
              url: 'https://github.com/goldbergyoni/javascript-testing-best-practices'
            }
          ]
        },
        {
          id: 'testing-2',
          title: 'Cypress - E2E Testing',
          type: 'Tutorial',
          description: 'Implementación de tests end-to-end con Cypress para testing completo de aplicaciones web.',
          tags: ['Cypress', 'E2E Testing', 'Frontend'],
          difficulty: 'Intermedio',
          estimatedTime: '1.5h',
          lastUpdated: '2024-01-16',
          author: 'Testing Team',
          downloads: 134,
          rating: 4.7,
          content: {
            sections: [
              {
                title: 'Instalación y Configuración',
                content: 'Setup completo de Cypress en proyectos frontend.',
                subsections: [
                  'Instalación de Cypress',
                  'Configuración inicial',
                  'Cypress config file',
                  'Environment setup',
                  'Browser configuration'
                ]
              },
              {
                title: 'Writing Tests',
                content: 'Escritura de tests efectivos con Cypress.',
                subsections: [
                  'Test structure',
                  'Selectors',
                  'Assertions',
                  'Waiting strategies',
                  'Test data'
                ]
              },
              {
                title: 'Custom Commands',
                content: 'Creación de comandos personalizados para reutilizar lógica común.',
                subsections: [
                  'Command syntax',
                  'Parameter passing',
                  'Return values',
                  'Command chaining',
                  'Best practices'
                ]
              },
              {
                title: 'Fixtures y Stubs',
                content: 'Uso de fixtures para datos de testing y stubs para APIs.',
                subsections: [
                  'Fixture files',
                  'Data management',
                  'API stubbing',
                  'Network mocking',
                  'Dynamic data'
                ]
              },
              {
                title: 'CI/CD Integration',
                content: 'Integración de Cypress en pipelines de CI/CD.',
                subsections: [
                  'GitHub Actions',
                  'GitLab CI',
                  'Jenkins',
                  'Parallel execution',
                  'Artifacts'
                ]
              }
            ]
          },
          attachments: [
            {
              name: 'Cypress-E2E-Guide.pdf',
              type: 'application/pdf',
              size: 1792000
            }
          ]
        }
      ]
    },
    {
      name: 'Estado & Gestión',
      icon: 'Database',
      resources: [
        {
          id: 'state-1',
          title: 'Redux Toolkit - Estado Global',
          type: 'Guía',
          description: 'Gestión de estado global con Redux Toolkit, incluyendo configuración, slices y mejores prácticas.',
          tags: ['Redux', 'Estado', 'React'],
          difficulty: 'Intermedio',
          estimatedTime: '2.5h',
          lastUpdated: '2024-01-08',
          author: 'State Management Team',
          downloads: 167,
          rating: 4.8,
          content: {
            sections: [
              {
                title: 'Configuración del Store',
                content: 'Setup del store de Redux con configuración optimizada.',
                subsections: [
                  'Store creation',
                  'Middleware setup',
                  'DevTools configuration',
                  'Store enhancers',
                  'Performance optimization'
                ]
              },
              {
                title: 'Slices y Reducers',
                content: 'Creación de slices para organizar el estado y reducers.',
                subsections: [
                  'createSlice syntax',
                  'Reducer functions',
                  'Action creators',
                  'Immer integration',
                  'Slice composition'
                ]
              },
              {
                title: 'Async Thunks',
                content: 'Manejo de operaciones asíncronas con createAsyncThunk.',
                subsections: [
                  'Thunk creation',
                  'Loading states',
                  'Error handling',
                  'Optimistic updates',
                  'Cancellation'
                ]
              },
              {
                title: 'RTK Query',
                content: 'Solución integrada para fetching de datos y cache management.',
                subsections: [
                  'API definition',
                  'Query hooks',
                  'Mutation hooks',
                  'Cache invalidation',
                  'Real-time updates'
                ]
              },
              {
                title: 'DevTools',
                content: 'Uso de Redux DevTools para debugging y desarrollo.',
                subsections: [
                  'DevTools setup',
                  'State inspection',
                  'Action history',
                  'Time travel debugging',
                  'Performance profiling'
                ]
              }
            ]
          },
          externalLinks: [
            {
              title: 'Redux Toolkit Documentation',
              description: 'Documentación oficial de Redux Toolkit',
              url: 'https://redux-toolkit.js.org/'
            }
          ]
        },
        {
          id: 'state-2',
          title: 'Zustand - Estado Simple',
          type: 'Tutorial',
          description: 'Gestión de estado ligera con Zustand para aplicaciones que no requieren la complejidad de Redux.',
          tags: ['Zustand', 'Estado', 'React'],
          difficulty: 'Básico',
          estimatedTime: '1h',
          lastUpdated: '2024-01-20',
          author: 'Frontend Team',
          downloads: 98,
          rating: 4.5,
          content: {
            sections: [
              {
                title: 'Instalación',
                content: 'Setup inicial de Zustand en proyectos React.',
                subsections: [
                  'Package installation',
                  'Basic setup',
                  'TypeScript support',
                  'DevTools integration',
                  'Project structure'
                ]
              },
              {
                title: 'Crear Store',
                content: 'Creación de stores simples y complejos con Zustand.',
                subsections: [
                  'Store syntax',
                  'State definition',
                  'Actions',
                  'Computed values',
                  'Store composition'
                ]
              },
              {
                title: 'Actions y Updates',
                content: 'Definición de acciones para modificar el estado.',
                subsections: [
                  'Action syntax',
                  'State updates',
                  'Async actions',
                  'Batch updates',
                  'Immutable updates'
                ]
              },
              {
                title: 'Subscriptions',
                content: 'Suscripción a cambios de estado y re-rendering.',
                subsections: [
                  'Component subscriptions',
                  'Selective updates',
                  'Performance optimization',
                  'Subscription cleanup',
                  'Custom selectors'
                ]
              },
              {
                title: 'Middleware',
                content: 'Uso de middleware para extender la funcionalidad de Zustand.',
                subsections: [
                  'Built-in middleware',
                  'Custom middleware',
                  'Persistence',
                  'DevTools',
                  'Logging'
                ]
              }
            ]
          }
        }
      ]
    },
    {
      name: 'APIs & Integración',
      icon: 'Globe',
      resources: [
        {
          id: 'api-1',
          title: 'Postman - Testing de APIs',
          type: 'Guía',
          description: 'Uso de Postman para testing y documentación de APIs, incluyendo collections, variables y automatización.',
          tags: ['Postman', 'API', 'Testing'],
          difficulty: 'Básico',
          estimatedTime: '1.5h',
          lastUpdated: '2024-01-14',
          author: 'API Team',
          downloads: 298,
          rating: 4.6,
          content: {
            sections: [
              {
                title: 'Configuración de Collections',
                content: 'Organización de requests en collections para mejor gestión.',
                subsections: [
                  'Collection structure',
                  'Request organization',
                  'Folder hierarchy',
                  'Collection sharing',
                  'Version control'
                ]
              },
              {
                title: 'Variables de Entorno',
                content: 'Uso de variables para diferentes entornos y configuración.',
                subsections: [
                  'Environment setup',
                  'Variable types',
                  'Dynamic variables',
                  'Variable scoping',
                  'Secret management'
                ]
              },
              {
                title: 'Tests Automatizados',
                content: 'Escritura de tests automatizados para validar respuestas de APIs.',
                subsections: [
                  'Test syntax',
                  'Assertions',
                  'Response validation',
                  'Test scripts',
                  'Test reports'
                ]
              },
              {
                title: 'Documentación',
                content: 'Generación automática de documentación de APIs.',
                subsections: [
                  'API documentation',
                  'Request examples',
                  'Response schemas',
                  'Interactive docs',
                  'Documentation sharing'
                ]
              },
              {
                title: 'Monitoreo',
                content: 'Monitoreo de APIs en producción con Postman.',
                subsections: [
                  'Monitor setup',
                  'Scheduled runs',
                  'Performance metrics',
                  'Alerting',
                  'Reports'
                ]
              }
            ]
          },
          attachments: [
            {
              name: 'Postman-API-Testing.pdf',
              type: 'application/pdf',
              size: 1536000
            }
          ]
        },
        {
          id: 'api-2',
          title: 'Fetch API vs Axios',
          type: 'Comparación',
          description: 'Análisis comparativo entre Fetch API nativa y Axios para HTTP requests en aplicaciones frontend.',
          tags: ['Fetch', 'Axios', 'HTTP'],
          difficulty: 'Básico',
          estimatedTime: '1h',
          lastUpdated: '2024-01-17',
          author: 'Frontend Team',
          downloads: 145,
          rating: 4.7,
          content: {
            sections: [
              {
                title: 'Sintaxis',
                content: 'Comparación de sintaxis y API entre Fetch y Axios.',
                subsections: [
                  'Basic requests',
                  'Request options',
                  'Response handling',
                  'Error handling',
                  'Request configuration'
                ]
              },
              {
                title: 'Interceptores',
                content: 'Capacidades de interceptores y middleware.',
                subsections: [
                  'Request interceptors',
                  'Response interceptors',
                  'Error interceptors',
                  'Global interceptors',
                  'Instance interceptors'
                ]
              },
              {
                title: 'Error Handling',
                content: 'Estrategias de manejo de errores en ambas librerías.',
                subsections: [
                  'HTTP errors',
                  'Network errors',
                  'Timeout handling',
                  'Retry logic',
                  'Error transformation'
                ]
              },
              {
                title: 'Cancelación',
                content: 'Mecanismos de cancelación de requests en curso.',
                subsections: [
                  'AbortController',
                  'Cancel tokens',
                  'Request cancellation',
                  'Cleanup',
                  'Memory management'
                ]
              },
              {
                title: 'Performance',
                content: 'Análisis de performance y optimización.',
                subsections: [
                  'Bundle size',
                  'Request overhead',
                  'Memory usage',
                  'Caching',
                  'Optimization tips'
                ]
              }
            ]
          }
        }
      ]
    },
    {
      name: 'Herramientas & Build',
      icon: 'Wrench',
      resources: [
        {
          id: 'tools-1',
          title: 'Webpack 5 - Configuración',
          type: 'Guía',
          description: 'Configuración avanzada de Webpack 5 para proyectos frontend, incluyendo optimización y code splitting.',
          tags: ['Webpack', 'Build Tool', 'Configuración'],
          difficulty: 'Avanzado',
          estimatedTime: '3h',
          lastUpdated: '2024-01-05',
          author: 'Build Team',
          downloads: 78,
          rating: 4.9,
          content: {
            sections: [
              {
                title: 'Entry y Output',
                content: 'Configuración de entry points y output para diferentes targets.',
                subsections: [
                  'Entry configuration',
                  'Output options',
                  'Multiple entries',
                  'Library targets',
                  'Path configuration'
                ]
              },
              {
                title: 'Loaders',
                content: 'Configuración de loaders para diferentes tipos de archivos.',
                subsections: [
                  'JavaScript loaders',
                  'CSS loaders',
                  'Asset loaders',
                  'Custom loaders',
                  'Loader options'
                ]
              },
              {
                title: 'Plugins',
                content: 'Uso de plugins para extender la funcionalidad de Webpack.',
                subsections: [
                  'Built-in plugins',
                  'Third-party plugins',
                  'Plugin configuration',
                  'Custom plugins',
                  'Plugin order'
                ]
              },
              {
                title: 'Optimización',
                content: 'Técnicas de optimización para mejorar el performance del build.',
                subsections: [
                  'Code splitting',
                  'Tree shaking',
                  'Minification',
                  'Compression',
                  'Bundle analysis'
                ]
              },
              {
                title: 'Code Splitting',
                content: 'Estrategias de code splitting para mejorar el loading performance.',
                subsections: [
                  'Dynamic imports',
                  'Entry splitting',
                  'Vendor splitting',
                  'Runtime splitting',
                  'Lazy loading'
                ]
              }
            ]
          },
          attachments: [
            {
              name: 'Webpack5-Configuracion.pdf',
              type: 'application/pdf',
              size: 3584000
            }
          ]
        },
        {
          id: 'tools-2',
          title: 'Vite - Build Tool Moderno',
          type: 'Tutorial',
          description: 'Migración de Webpack a Vite para desarrollo rápido y builds optimizados.',
          tags: ['Vite', 'Build Tool', 'Modern'],
          difficulty: 'Intermedio',
          estimatedTime: '1.5h',
          lastUpdated: '2024-01-19',
          author: 'DevOps Team',
          downloads: 123,
          rating: 4.6,
          content: {
            sections: [
              {
                title: 'Instalación',
                content: 'Setup inicial de Vite en proyectos existentes.',
                subsections: [
                  'Package installation',
                  'Project setup',
                  'Configuration files',
                  'Environment setup',
                  'Migration from Webpack'
                ]
              },
              {
                title: 'Configuración',
                content: 'Configuración de Vite para diferentes tipos de proyectos.',
                subsections: [
                  'Vite config',
                  'Plugin configuration',
                  'Build options',
                  'Dev server options',
                  'CSS configuration'
                ]
              },
              {
                title: 'Plugins',
                content: 'Uso de plugins oficiales y de terceros con Vite.',
                subsections: [
                  'Official plugins',
                  'Community plugins',
                  'Plugin development',
                  'Plugin configuration',
                  'Plugin ecosystem'
                ]
              },
              {
                title: 'HMR',
                content: 'Hot Module Replacement para desarrollo rápido.',
                subsections: [
                  'HMR configuration',
                  'HMR APIs',
                  'Custom HMR',
                  'HMR performance',
                  'HMR debugging'
                ]
              },
              {
                title: 'Build para Producción',
                content: 'Configuración de builds optimizados para producción.',
                subsections: [
                  'Build optimization',
                  'Asset handling',
                  'Code splitting',
                  'Bundle analysis',
                  'Deployment'
                ]
              }
            ]
          }
        }
      ]
    }
  ]
};
